export const DEFAULT_AGE = '18'
